import React from 'react'
import WatchAllCloseCarbon from '../../components/NewLandingPage/WatchAllCloseCarbon'
import Footer from '../../components/shared/Footer'
function WatchAll() {
  return (
    <div><WatchAllCloseCarbon />
    <Footer/>
    </div>
  )
}

export default WatchAll